import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind-merge aware class composition helper. Use everywhere instead of raw `clsx`. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
